// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__13Gyu","signatureBlock":"Footer_signatureBlock__2OVUA","signature":"Footer_signature__3N1Rw"};